import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"

export const AgendaTask = ({ task }) => {
    return (
        <div className="tile tile--agenda">
            <div className="tile--agenda__info">
                {task.hour && <p>{task.hour}</p>}
                <h5>{task.title}</h5>
                <p>{task.description}</p>
            </div>
            {task.image && <div className="tile--agenda__avatars grid-sm-2">
                {task.image && <div>
                    <GatsbyImage image={getImage(task.image.localFile)} alt={task.image.alternativeText} />
                    <h1>{task.name}</h1>
                    <p>{task.position}</p>
                </div>}
            </div>}
        </div>
    )
}